import { CALL_API } from '../middleware/api'

export const ARQUEOS_REQUEST = 'ARQUEOS_REQUEST'
export const ARQUEOS_SUCCESS = 'ARQUEOS_SUCCESS'
export const ARQUEOS_FAILURE = 'ARQUEOS_FAILURE'

export function fetchArqueos(Machine, CustomerOrCustomers, StartDate, EndDate, Country, ContractType) {
  const params = new URLSearchParams()

  const addIfPresent = (key, val) => {
    if (val === undefined || val === null) return
    if (typeof val === 'string' && val.trim() === '') return
    params.append(key, val)
  }

  addIfPresent('Machine', Machine)

  // Accept string or array for customer(s)
  if (Array.isArray(CustomerOrCustomers)) {
    if (CustomerOrCustomers.length === 1) {
      addIfPresent('Customer', CustomerOrCustomers[0])
    } else if (CustomerOrCustomers.length > 1) {
      CustomerOrCustomers.forEach(id => addIfPresent('Customer', id))
    }
    // if empty array -> no Customer param
  } else {
    // single-customer legacy usage
    addIfPresent('Customer', CustomerOrCustomers)
  }

  addIfPresent('Country', Country)
  addIfPresent('StartDate', StartDate)
  addIfPresent('EndDate', EndDate)
  addIfPresent('ContractType', ContractType)

  const query = params.toString()

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: query ? `arqueos?${query}` : 'arqueos',
      authenticated: true,
      types: [ARQUEOS_REQUEST, ARQUEOS_SUCCESS, ARQUEOS_FAILURE]
    }
  }
}

export const ARQUEOS_SALES_REQUEST = 'ARQUEOS_SALES_REQUEST'
export const ARQUEOS_SALES_SUCCESS = 'ARQUEOS_SALES_SUCCESS'
export const ARQUEOS_SALES_FAILURE = 'ARQUEOS_SALES_FAILURE'

export function fetchSalesArqueos(BusinessModel, Customer, StartDate, EndDate, Country) {
  let params = ''

  if (BusinessModel !== undefined) {
    params += `&BusinessModel=${BusinessModel}`
  }

  if (Customer !== undefined) {
    params += `&Customer=${Customer}`
  }

  if (Country !== undefined) {
    params += `&Country=${Country}`
  }

  if (StartDate !== undefined) {
    params += `&StartDate=${StartDate}`
  }

  if (EndDate !== undefined) {
    params += `&EndDate=${EndDate}`
  }

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/sales?${params}`,
      authenticated: true,
      types: [ARQUEOS_SALES_REQUEST, ARQUEOS_SALES_SUCCESS, ARQUEOS_SALES_FAILURE]
    }
  }
}

export const ARQUEO_REQUEST = 'ARQUEO_REQUEST'
export const ARQUEO_SUCCESS = 'ARQUEO_SUCCESS'
export const ARQUEO_FAILURE = 'ARQUEO_FAILURE'

export function fetchArqueo(Serial) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `arqueos/${Serial}`,
      authenticated: true,
      types: [ARQUEO_REQUEST, ARQUEO_SUCCESS, ARQUEO_FAILURE]
    }
  }
}